var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activityproduct_div"
  }, [_c("a-card", {
    staticClass: "first_class",
    staticStyle: {
      "margin-top": "24px",
      flex: "1"
    },
    attrs: {
      title: _vm.$t("activity.commodityrange"),
      bordered: false
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("activity.tips"),
      description: _vm.$t("activity.tipsContent"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }), _c("br"), _c("a-form-model", {
    ref: "rangeRuleForm",
    attrs: {
      rules: _vm.rangeRules,
      model: _vm.chooseproductparam
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    attrs: {
      disabled: _vm.redioDisabled
    },
    on: {
      change: function change($event) {
        return _vm.rangetypeChange();
      }
    },
    model: {
      value: _vm.chooseproductparam.productType,
      callback: function callback($$v) {
        _vm.$set(_vm.chooseproductparam, "productType", $$v);
      },
      expression: "chooseproductparam.productType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.yesproduct")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.noproduct")) + " ")])], 1)], 1), _vm.chooseproductparam.productType != 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("activity.integralmultiple"),
      prop: "activityContent"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      min: 1,
      max: 999999999
    },
    model: {
      value: _vm.chooseproductparam.activityContent,
      callback: function callback($$v) {
        _vm.$set(_vm.chooseproductparam, "activityContent", $$v);
      },
      expression: "chooseproductparam.activityContent"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("activity.multiple")) + " ")], 1) : _vm._e()], 1), _vm.chooseproductparam.productType != 0 ? _c("div", {
    staticClass: "product_div"
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-upload", {
    staticStyle: {
      "margin-bottom": "16px",
      "text-align": "right",
      "margin-right": "8px"
    },
    attrs: {
      headers: _vm.newheaders,
      action: _vm.action,
      "before-upload": _vm.beforeUpload,
      showUploadList: false,
      multiple: "",
      limit: 1
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "import"
    },
    on: {
      click: function click($event) {
        return _vm.importProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.importGoods")) + " ")])], 1), _c("a-tooltip", {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("activity.firstlineprompt")))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("activity.secondlineprompt")))])]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table", {
    ref: "productList",
    attrs: {
      "row-selection": {
        onSelectAll: _vm.onSelectAll,
        onSelect: _vm.onSelect,
        onChange: _vm.onChange,
        selectedRowKeys: _vm.selectedRowKeys
      },
      rowKey: "productNo",
      pagination: {
        pageSizeOptions: ["5", "10", "20", "30"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      },
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.productList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "product-status",
      fn: function fn(text, record) {
        return _c("span", {}, [text == 0 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.normal")) + " ")]) : _vm._e(), text == 1 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.invalid")) + " ")]) : _vm._e()], 1);
      }
    }, {
      key: "activity-content",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productStatus == 0 ? _c("span", [_c("a-input-number", {
          attrs: {
            disabled: _vm.redioDisabled,
            min: 1,
            max: 99999999
          },
          model: {
            value: record.activityContent,
            callback: function callback($$v) {
              _vm.$set(record, "activityContent", $$v);
            },
            expression: "record.activityContent"
          }
        })], 1) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "goodsname",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "goods_name"
        }, [_c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.productId
              }
            }
          }
        }, [_vm._v(" " + _vm._s(text) + " ")])], 1)], 2), record.productOptionName != "" ? _c("span", [_c("br")]) : _vm._e(), record.productOptionName != "" ? _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.productOptionName) + " ")]), _c("span", {
          staticClass: "goods_name"
        }, [_c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.productId
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.productOptionName) + " ")])], 1)], 2) : _vm._e()], 1);
      }
    }, {
      key: "pricetax",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_vm._v(_vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(text)) + _vm._s(_vm.rightCurrencySymbol))])]);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.sureremove"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("publicuse.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.remove")))])])], 1);
      }
    }], null, false, 2680123869)
  }, [_c("span", {
    attrs: {
      slot: "goodsnametitle"
    },
    slot: "goodsnametitle"
  }, [_vm._v(_vm._s(_vm.$t("publicuse.goodsname")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "exclamation-circle",
      rotate: 180
    }
  })], 2)], 1)]), this.chooseproductparam.productType != 0 ? _c("div", {
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.selected")) + _vm._s(_vm.selectNumber) + _vm._s(_vm.$t("public.term")))]), _c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.batchoperation")))]), this.chooseproductparam.productType == 1 ? _c("a-button", {
    staticStyle: {
      "margin-right": "16px"
    },
    on: {
      click: function click($event) {
        return _vm.removeClick(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("activity.setintegral")) + " ")]) : _vm._e(), _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.removeClick(2);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.remove")))])], 1) : _vm._e()], 1) : _vm._e()], 1), _c("footer-tool-bar", [_c("a-button", {
    staticStyle: {
      "margin-right": "16px"
    },
    on: {
      click: _vm.prevStep
    }
  }, [_vm._v(_vm._s(_vm.$t("public.previousstep")))]), _c("a-button", {
    attrs: {
      loading: _vm.updateLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveActivity
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")) + " ")])], 1), _c("a-modal", {
    attrs: {
      width: "320px",
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.removeTypeVisible,
      callback: function callback($$v) {
        _vm.removeTypeVisible = $$v;
      },
      expression: "removeTypeVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      rules: _vm.modalRules,
      model: _vm.modalValue
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    on: {
      change: function change($event) {
        return _vm.removeTypeChange();
      }
    },
    model: {
      value: _vm.modalValue.removeType,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "removeType", $$v);
      },
      expression: "modalValue.removeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.checktheitem")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1), _vm.buttonType == 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("activity.integralmultiple"),
      prop: "discount"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "250px"
    },
    attrs: {
      min: 1,
      max: 99999999
    },
    model: {
      value: _vm.modalValue.discount,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "discount", $$v);
      },
      expression: "modalValue.discount"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("activity.multiple")) + " ")], 1) : _vm._e()], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.removeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2), _c("importfailed", {
    attrs: {
      visible: _vm.importVisible,
      importObj: _vm.importObj
    },
    on: {
      "get-visible": _vm.getVisible
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };